<div class="cylinder-table-row text">
    <div class="col-no column">
        {{ rowIndex + 1 }}
    </div>
    <div class="col-temp column">
        <ng-container *ngIf="!channel?.tempChannel">
            <div class="select-button" (click)="openChannelSelector()">
                {{ 'graph.exhaust.table.average.button.select' | translate }}
            </div>
        </ng-container>
        <ng-container *ngTemplateOutlet="channelRow; context: { channel: channel?.tempChannel }"></ng-container>
    </div>
    <div class="col-options column" #iconButton>
         <app-more-options-dropdown
            [isOpen]="optionsVisible"
            (toggle)="openOptions()"
            [options]="moreOptions"
            (optionSelected)="onMoreOptionSelected($event)">
        </app-more-options-dropdown>
    </div>
</div>

<ng-template #channelRow let-channel="channel">
    <div class="channel-row" *ngIf="channel">
        <div class="channel-name" data-cy="graphs-exh-gas-turbo-table-channel-label">
            {{ channel.fcuData.fcuChannelId + ' ' + channel.opsData.name }}
        </div>
        <div class="select-button" (click)="openChannelSelector()">
            {{ 'graph.exhaust.table.channel.button.change' | translate }}
        </div>
    </div>
</ng-template>